"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIToggleGroup;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _devWarnings = require("../utils/devWarnings");

/**
 * Group clusters of Radio/Checkbox Buttons together, with common styling
 **/
function UIToggleGroup(props) {
  /* eslint-disable react/prop-types */
  var children = props.children,
      __error = props.error,
      inline = props.inline,
      name = props.name,
      rest = (0, _objectWithoutProperties2.default)(props, ["children", "error", "inline", "name"]);
  return _react.default.createElement("div", rest, _react.default.Children.map(children, function (child) {
    (0, _devWarnings.warnIfFragment)(child, UIToggleGroup.displayName);
    return child && child.type && _react.default.cloneElement(child, Object.assign({
      inline: inline,
      name: name
    }, child.props));
  }));
}

UIToggleGroup.propTypes = {
  children: _propTypes.default.node.isRequired,
  inline: _propTypes.default.bool,
  name: _propTypes.default.string.isRequired
};
UIToggleGroup.displayName = 'UIToggleGroup';
module.exports = exports.default;